export interface SelectOption {
  value: string;
  label: string;
}

const toOptions = (names: string[]): SelectOption[] =>
  names
    .map((name) => name.trim())
    .filter(Boolean)
    .map((name) => ({
      value: name,
      label: name,
    }));

// Commercial banks in Nepal
export const bankOptions: SelectOption[] = toOptions([
  "Agricultural Development Bank Limited",
  "Citizens Bank International Limited",
  "Everest Bank Limited",
  "Global IME Bank Limited",
  "Himalayan Bank Limited",
  "Kumari Bank Limited",
  "Laxmi Sunrise Bank Limited",
  "Machhapuchchhre Bank Limited",
  "Nabil Bank Limited",
  "Nepal Bank Limited",
  "Nepal Investment Mega Bank Limited",
  "Nepal SBI Bank Limited",
  "NIC ASIA Bank Limited",
  "NMB Bank Limited",
  "Prabhu Bank Limited",
  "Prime Commercial Bank Limited",
  "Rastriya Banijya Bank Limited",
  "Sanima Bank Limited",
  "Siddhartha Bank Limited",
  "Standard Chartered Bank Nepal Limited",
]);

// Examples of cooperatives in Nepal.
// Add the remaining registered cooperatives from the official registry.
export const cooperativeOptions: SelectOption[] = toOptions([
  "Chhimek Saving and Credit Cooperative Society Limited",
  "Deprosc Laghubitta Bittiya Sanstha Limited",
  "Kisan Bahuuddeshiya Sahakari Sanstha Limited",
  "Maha Laxmi Saving and Credit Cooperative Limited",
  "Nepal Multipurpose Cooperative Society Limited",
  "Sana Kisan Bikas Laghubitta Bittiya Sanstha Limited",
  "Sahara Saving and Credit Cooperative Limited",
  "Sajha Cooperative",
  "Samriddhi Saving and Credit Cooperative Society Limited",
  "Shree Laligurans Multipurpose Cooperative Society Limited",
]);

// Combined list for a single dropdown
export const financialInstitutionOptions: SelectOption[] = toOptions([
  ...bankOptions.map((item) => item.label),
  ...cooperativeOptions.map((item) => item.label),
]);
